import { useEffect } from 'react';

const useBodyTheme = (themeName?: string): void => {
  useEffect(() => {
    if (!themeName) {
      return undefined;
    }
    document.body.setAttribute('data-theme-name', themeName);
    return () => {
      document.body.removeAttribute('data-theme-name');
    };
  }, [themeName]);
};

export default useBodyTheme;
